<template>
  <div class="review">
    <div class="reviewTitle">Click on a Question below to Review & Edit</div>
    <div class="reviewSubTitle">
      can rovlew any duestion (regardoss of bookmark status) and edit up to
      three (3) answers in this section bef he sedtondne exoires The section
      time and number of answer edits remaining are shown in the upper
      right-hand corne
    </div>
    <div style="display: flex; flex-wrap: wrap">
      <div v-for="(item, index) in questionList" :key="index">
        <table
          border="1"
          style="
            border-collapse: collapse;
            border-color: #707070;
            margin-right: 20px;
            margin-bottom: 20px;
          "
        >
          <tr>
            <th>Question</th>
            <th>Bookmarked</th>
          </tr>
          <tr v-for="(z, i) in item" :key="i" @click="goMark(z)">
            <td>
              {{ 10 * index + i + 1 }}
            </td>
            <td>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img src="@/assets/mark.png" alt="" v-if="z.mark === 1" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/dryRun.js";
export default {
  data() {
    return {
      questionList: [],
    };
  },
  methods: {
    async getList() {
      const res = await api.review({
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
        type: sessionStorage.getItem("topicCType"),
      });
      if (res.data.code === 0) {
        let index = 0;
        this.questionList = [];
        res.data.data.forEach((z, i) => {
          if (i == 0) {
            this.questionList.push([]);
          } else if (i % 10 == 0) {
            this.questionList.push([]);
            index++;
          }
          this.questionList[index].push(z);
        });
        sessionStorage.setItem("choice", JSON.stringify(res.data.choice));
        if (res.data.answer) {
          this.goMark(res.data.answer);
        }
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async goMark(item) {
      if (item.modify_count >= 2) {
        this.$message.error("一道题只可修改两次");
        return;
      }
      sessionStorage.setItem("q_id", item.q_id);
      const path = [
        "/singleChoice",
        "/completion",
        "/doubleChoice",
        "/singleChoiceBoolean",
        "/examinContent/systemRead",
        "/imageAnalysis",
        "/table",
        "/reasoning",
        "/choice"
      ];
      const nextType = item.nextType;
      if (nextType >= 1 && nextType <= 9) {
        if (this.$route.path === path[nextType - 1]) {
          this.reload();
        } else {
          this.$router.replace({
            path: path[nextType - 1],
          });
        }
      }
    },
  },
  mounted() {
    sessionStorage.setItem("review", true);
    this.getList();
  },
};
</script>

<style scoped>
.review {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.review .reviewTitle {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
}
.review .reviewSubTitle {
  font-size: 18px;
  margin-bottom: 15px;
}
.review table th {
  height: 30px;
  font-size: 16px;
  width: 150px;
  background: #63aae0;
  color: #fff;
}
.review table td {
  color: #63aae0;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;

  cursor: pointer;
}
.review table img {
  height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/view/review/review.vue